import { render, staticRenderFns } from "./CustomersEdit.vue?vue&type=template&id=2514d0ad&scoped=true"
import script from "./CustomersEdit.vue?vue&type=script&lang=js"
export * from "./CustomersEdit.vue?vue&type=script&lang=js"
import style0 from "./CustomersEdit.vue?vue&type=style&index=0&id=2514d0ad&prod&lang=scss&scoped=true"
import style1 from "./CustomersEdit.vue?vue&type=style&index=1&id=2514d0ad&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2514d0ad",
  null
  
)

export default component.exports